/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Sports_NutritionInputs */

const en_service_type_sports_nutrition = /** @type {(inputs: Service_Type_Sports_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports nutrition`)
};

const pl_service_type_sports_nutrition = /** @type {(inputs: Service_Type_Sports_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietetyka sportowa`)
};

/**
* | output |
* | --- |
* | "Sports nutrition" |
*
* @param {Service_Type_Sports_NutritionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_sports_nutrition = /** @type {((inputs?: Service_Type_Sports_NutritionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Sports_NutritionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_sports_nutrition(inputs)
	return en_service_type_sports_nutrition(inputs)
});